import { useState } from 'react';
import { PaymentProfileDigest, trackDigest } from 'helpers/paymentProfile';
import { ETelemetryNames } from 'telemetry/type';

export function useTrackStatus() {
    const [hasEmittedTelemetry, setHasEmittedTelemetry] = useState(false);
    return (digest: PaymentProfileDigest) => {
        if (!hasEmittedTelemetry) {
            trackDigest(ETelemetryNames.PaymentProfile, digest);
            setHasEmittedTelemetry(true);
        }
    };
}
